import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { guides } from "../content/guides";

export function GuidesPage() {
  return (
    <section className="guides-page page-container">
      <Seo title="Guias de doramas: onde assistir, dublados e sem assinatura | DoramaFlix" description="Guias para assistir doramas online, encontrar títulos dublados e entender o acesso sem assinatura." path="/guias" />
      <header className="article-header centered">
        <p className="eyebrow">GUIAS</p>
        <h1>Guias para assistir doramas online</h1>
        <p>Onde assistir novelinhas dubladas, quais títulos escolher e como funciona o acesso sem assinatura mensal.</p>
      </header>
      <div className="guide-grid">
        {guides.map((guide, index) => (
          <Link className="guide-card" to={`/guias/${guide.slug}`} key={guide.slug}>
            <span className="guide-number">0{index + 1}</span>
            <h2>{guide.title}</h2>
            <p>{guide.description}</p>
            <span>{guide.readTime} · Ler guia →</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
